export const schoolWishlistKeys = {
    all: ['school-wishlist'] as const,
    ids: () => [...schoolWishlistKeys.all, 'ids'] as const
} as const;

// Invalidations:
// useSubscribeSchool   → optimistic on schoolWishlistKeys.ids(); on settle invalidates schoolWishlistKeys.all +
//                        schoolWishlistVotesKeys.voters(materialId) + baseSearchKeys.all
// useUnsubscribeSchool → optimistic on schoolWishlistKeys.ids(); on settle invalidates schoolWishlistKeys.all +
//                        schoolWishlistVotesKeys.voters(materialId) + baseSearchKeys.all
// useVoteSchoolWishlist / useUnvoteSchoolWishlist → schoolWishlistKeys.all
//
// Redux bridge: for a school master in the DE world this wishlist also lives in Redux state.main.favorite.
// The mutations' call sites dispatch getFavorite(); hooks/use-change-favorite.ts covers the reverse direction.
